module.exports = __webpack_public_path__ + "img/help1-2-4.f04fd8f6.png";